import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function Login({ setIsAuthenticated }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      // Send credentials to /api/login
      const response = await axios.post('https://thornsdashboard.com/api/login', {
        username,
        password,
      });

      const { token, refreshToken, user } = response.data;

      if (!token || !user) {
        throw new Error('Invalid response from server');
      }

      // ✅ Store everything in localStorage
      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refreshToken || '');
      localStorage.setItem('role', user.role);      // 👈 role for frontend checks
      localStorage.setItem('username', user.username);

      console.log(`[Login] ✅ Stored token + role (${user.role}) for user ${user.username}`);

      // ✅ Update authentication state
      setIsAuthenticated(true);

      // ✅ Redirect after login
      navigate('/');
    } catch (err) {
      console.error('[Login] ❌ Login failed:', err.response?.data || err.message);
      setError(err.response?.data?.error || 'Invalid username or password. Please try again.');
    }
  };

  return (
    <Container className="mt-5">
      <Row>
        <Col md={{ span: 4, offset: 4 }}>
          <Card>
            <Card.Body>
              <Card.Title>Login</Card.Title>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="username">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Form.Group>
                <Button variant="primary" type="submit">
                  Login
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
